

























import { Inject, Component, Vue } from 'vue-property-decorator'
import { WinckOffice, WinckScreen } from '@/api/client/winck-proxy'
import Info from '@/views/Company/Settings/Narrowcasting/Info.vue'
import { namespace } from 'vuex-class'
const narrowcasting = namespace('narrowcasting')

@Component({
    components: {
        Info,
    },
})
export default class CompanySettingsNarrowcastingScreensList extends Vue {
    @Inject() readonly navigateToCreate: () => Promise<void>
    @Inject() readonly navigateToEdit: (screenId: string) => Promise<void>
    @narrowcasting.State readonly offices!: WinckOffice[]
    @narrowcasting.State readonly screens!: WinckScreen[]
    @narrowcasting.Action readonly deleteScreen: (screen: WinckScreen) => Promise<void>

    async editItem(screen: WinckScreen): Promise<void> {
        await this.navigateToEdit(screen.id)
    }

    async deleteItem(screen: WinckScreen): Promise<void> {
        if (confirm(this.$t('narrowcasting.screens.list.delete').toString())) {
            await this.deleteScreen(screen)
        }
    }

    getOfficeName(officeId): string {
        return this.offices.find(office => office.id === officeId).name
    }
}
